'use client';

import { resolveLegacyJobImageProxyUrl } from '@/ai/jobs/client/legacy-job-image-url';
import {
  TransparentAwareImage,
  type TransparentAwareImageProps,
} from '@/components/ui/media/transparent-aware-image';

type HistoryCachedImageProps = Omit<TransparentAwareImageProps, 'src'> & {
  src: string | null | undefined;
};

export function HistoryCachedImage({
  src,
  transparencyFallbackSrc,
  ...props
}: HistoryCachedImageProps) {
  if (!src) return null;

  const resolvedTransparencyFallbackSrc =
    transparencyFallbackSrc ?? resolveLegacyJobImageProxyUrl(src);

  return (
    <TransparentAwareImage
      src={src}
      transparencyFallbackSrc={resolvedTransparencyFallbackSrc}
      {...props}
    />
  );
}
